import React, { FunctionComponent } from 'react'

import { Box, BoxProps, Typo } from '../atoms'

export const InputMessage: FunctionComponent<BoxProps> = ({ children, ...props }) => (
  <Box py={3} {...props}>
    <Typo typoSize='sm'>{children}</Typo>
  </Box>
)
